import type { FeatureFlagsEnvironment } from '@susu/feature-flags';

// Public client-side SDK keys (browser-readable by design, not credentials).
// China environments share these via normalizeEnvironment().
export const FEATURE_FLAGS_CLIENT_KEYS: Record<FeatureFlagsEnvironment, string> = {
  dev: 'sdk-6q0B2NkTdBxQQXW',
  tst: 'sdk-6q0B2NkTdBxQQXW',
  acc: 'sdk-bNsQk0lPGnVL6QvX',
  prd: 'sdk-mn0L1Tr8PhosfCd',
};
